import { EVENTS as BaseEvents } from '@/app/shared/utils/constants';
import { apiConstants } from './api-constants';
let code = apiConstants.code;

export const EVENTS = {
    SELECT_FEATURE: BaseEvents.SELECT_FEATURE,
    UNSELECT_FEATURE: BaseEvents.UNSELECT_FEATURE,
    UPDATE_FEATURE: BaseEvents.UPDATE_FEATURE,
    INITIALIZE_NEW_ACCIDENT: 'map.new-accident-initialize',
    FINISHED_NEW_ACCIDENT: 'map.new-accident-finished',
    SHOW_MODAL_NEW_ACCIDENT: `${code}:new-accident-show-modal`,
    SHOW_MODAL_DETAIL_ACCIDENT: `${code}:detail-accident-show-modal`,
    CLOSE_MODAL_DETAIL_ACCIDENT: `${code}:detail-accident-close-modal`,
    SHOW_MODAL_EDIT_ACCIDENT: `${code}:edit-accident-show-modal`,
    CLOSE_MODAL_EDIT_ACCIDENT: `${code}:edit-accident-close-modal`,
};